export default __webpack_public_path__ + "static/media/ebay.5ee02f33.svg";